import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {
  IIncreaseHistoryTable,
  IVacationDaysTable,
} from 'src/app/interfaces/general-tables.interface';
import {AccessManagementService} from 'src/app/services/access-management.service';
import {SalaryService} from 'src/app/services/accountant/salary.service';
import {DialogService} from 'src/app/services/dialog.service';
import {EmployeeService} from 'src/app/services/employee.service';
import {
  columnTypes,
  ITableRowAction,
  UITableHeader,
} from 'src/app/shared/ui-kits/table/table.models';
import {roles} from 'src/app/shared/utils/roles';
import {VacationPopupComponent} from '../salary-extended/vacation-popup/vacation-popup.component';
import {filter, switchMap} from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'app-salary',
  templateUrl: './salary.component.html',
  styleUrls: ['./salary.component.scss'],
})
export class SalaryComponent implements OnInit {
  public dataSalary: IIncreaseHistoryTable[] = [];
  public dataVacation!: IVacationDaysTable[];

  public headersCertHistory: UITableHeader[] = [
    {key: 'increaseDate', index: 0, type: columnTypes.datePicker},
    {key: 'reason', index: 1},
    {key: 'comment', index: 2},
  ];

  public headersCertVacation: UITableHeader[] = [
    {key: 'startDate', index: 0, type: columnTypes.datePicker},
    {key: 'vacationPeriod', index: 1},
    {key: 'providedVacationDays', index: 2},
    {key: 'usedVacationDays', index: 3},
    {key: 'dateOfAnnulment', index: 4, type: columnTypes.datePicker},
    {key: 'amountOfDaysToBeAnnuled', index: 5},
    {key: 'accumulatedVacationDaysAtTheMonth', index: 6},
  ];
  public employeeId!: number;
  public isAccountant!: boolean;

  constructor(
    private employeeService: EmployeeService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private acess: AccessManagementService,
    private dialogService: DialogService,
    private salary: SalaryService
  ) {}

  ngOnInit(): void {
    this.employeeId = +this.activatedRoute.parent?.snapshot.params['id'];
    this.employeeService
      .getSalaryData(this.employeeId)
      .pipe(untilDestroyed(this))
      .subscribe(data => {
        this.dataSalary = data.salaries;
      });

    this.salary
      .getAllEmployeeVacations(this.employeeId)
      .pipe(untilDestroyed(this))
      .subscribe(data => (this.dataVacation = data));

    this.isAccountant = this.acess.checkPermissions(
      roles.ACCOUNTANT_DEPARTMENT
    );
  }

  goToSalaryRoute() {
    this.router.navigate([`salary/main/${this.employeeId}/current-month`]);
  }

  showDialog(event: ITableRowAction) {
    this.dialogService
      .open(VacationPopupComponent, {
        data: this.dataVacation[event.index].dateOfAnnulment,
        settings: {},
      })
      .afterClosed()
      .pipe(
        untilDestroyed(this),
        filter(data => !!data),
        switchMap(data => {
          const body = {
            id: this.dataVacation[event.index].id as number,
            annulationDate: data,
          };
          return this.salary.updateVacation(body, this.employeeId);
        })
      )
      .subscribe(data => (this.dataVacation = data));
  }
}
